import React from 'react';

import BaseClass from '@/pages/BaseClass';

import {httpPost, ngUrl, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'peopleList': {},
            'categoryList': [],
            'filter': {
                'type': '02',
                'people': '',
                'subject': '',
                'keywords': '',
            },

            'list': [],
            'nextPage': 0,
        };
    }

    componentDidMount() {
        this.getCategoryList();
        this.getList();
        this.getPeopleList();
    }

    getPeopleList() {
        let url = pcUrl('/dict/data', {'dictType': 'school_type'});
        httpPost(url, {}, 'get', {
            'rawResponse': true,
        })
            .then(data => {
                let peopleList = {};
                data.rows.forEach(row => {
                    peopleList[row['dictValue']] = row['dictLabel'];
                });
                this.setState({peopleList});
            });
    }

    getCategoryList() {
        let url = pcUrl('/course/subject?type=technology');
        httpPost(url, {}, 'get')
            .then(data => {
                this.setState({
                    'categoryList': data,
                });
            });
    }

    selectFilter(key, value) {
        let filter = this.state.filter;
        filter[key] = value;
        this.setState({filter}, () => {
            this.getList();
        });
    }

    getList() {
        let url = pcUrl('/course');
        let param = this.state.filter;

        httpPost(url, param)
            .then((data) => {
                this.setState({
                    'list': data,
                });
            });
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">
                    <div className="list-category">
                        <div className="category-row">
                            <div className="category-label">
                                适合学生：
                            </div>
                            <div className="category-value">
                                <ul>
                                    <li>
                                        <a href="javascript:;" onClick={() => this.selectFilter('people', '')}
                                           className={this.state.filter.people == '' ? 'now' : ''}> 全部 </a>
                                    </li>
                                    {Object.keys(this.state.peopleList).map(key => (
                                        <li>
                                            <a href="javascript:;" onClick={() => this.selectFilter('people', key)}
                                               className={this.state.filter.people == key ? 'now' : ''}> {this.state.peopleList[key]} </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="category-row">
                            <div className="category-label">
                                所属分类：
                            </div>
                            <div className="category-value">
                                <ul>
                                    <li>
                                        <a href="javascript:;" onClick={() => this.selectFilter('subject', '')}
                                           className={this.state.filter.subject == '' ? 'now' : ''}> 全部 </a>
                                    </li>
                                    {this.state.categoryList.map(key => (
                                        <li style={{'width': '9em'}}>
                                            <a style={{'width': '9em'}} href="javascript:;"
                                               onClick={() => this.selectFilter('subject', key['v'])}
                                               className={this.state.filter.subject == key ? 'now' : ''}> {key['n']} </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="height-30"></div>
                    {this.state.list.length > 0 ? (
                        <div className="class-list">
                            {this.state.list.map((row, index) => (
                                <div className={["class-list-li", index % 4 == 3 ? 'spec' : ''].join(' ')}>
                                    <div className="class-thumb">
                                        <a href="javascript:;"
                                           onClick={() => window.open(ngUrl('generalTechnology', {'id': row.id}), '_blank')}>
                                            <img src={"https://vod.jscqe.com/" + row.thumbUrl || require("@/assets/images/class_thumb.jpg")}/>
                                        </a>
                                    </div>
                                    <div className="class-body">
                                        <dl>
                                            <dt>
                                                <a href="javascript:;"
                                                   onClick={() => window.open(ngUrl('generalTechnology', {'id': row.id}), '_blank')}>{row.name}</a>
                                            </dt>
                                            <dd>
                                                所属分类：
                                                {row['subject'].split(',').map(key => {
                                                    let find = this.state.categoryList.find(row1 => row1.v == key);
                                                    return find ? find.n : '';
                                                }).join('，') || '无'}
                                            </dd>
                                        </dl>
                                    </div>
                                    <div className="class-foot">
										<span className="float-right text-sky">
											<span className="clips list-foot-user-ico"></span>
                                            {row.heat || 0}人
										</span>
                                        <ul>
                                            {row.keywords.length > 0 ? row.keywords.split(',').map(keyword => (
                                                <li><a href="javascript:;"> {keyword} </a></li>
                                            )) : (
                                                <>
                                                    &nbsp;
                                                </>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                            <div className="clear"></div>
                        </div>
                    ) : (
                        <div className="padding-20 text-center text-gray">暂无数据</div>
                    )}
                    <div className="height-30"></div>
                </div>
            </>
        );
    }
}
